/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Sign_In_Sent_DescriptionInputs */



/**
* | output |
* | --- |
* | "If that address can sign in here, a link is on its way. It expires in 30 minutes." |
*
* @param {Canvas_Sign_In_Sent_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_sign_in_sent_description = /** @type {((inputs?: Canvas_Sign_In_Sent_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Sign_In_Sent_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Falls sich diese Adresse hier anmelden kann, ist ein Link unterwegs. Er läuft in 30 Minuten ab.")
	return /** @type {LocalizedString} */ ("If that address can sign in here, a link is on its way. It expires in 30 minutes.")
});